export default {
  variants: {
    page: {
      width: '100%',
      py: 0,
      px: [5, 10, 20],
      maxWidth: '100%',
    },
  },
  defaultProps: {
    variant: 'page',
  },
}
